export function BrandBadge() {
  return (
    <span className="py-2 px-3 underline shadow-xl bg-green-700 text-indigo-100 text-sm">
      <a href="https://john.shiksha/">made by rengwu</a>
    </span>
  );
}
